
import React from "react";


const ForeignRightsIntro = ({ introData, categoryCTA, pdfURL }) => {

    return (
        <div className="container main-container merchandise-space">
             <h2 className="A-la-venta-esta-sema ">Foreign Rights</h2>
            <div className="line4"></div>
            <div className="foreign_rights_intro_wrapper">
                <div className="left_sec">
                    <div className="intro" dangerouslySetInnerHTML={{ __html: introData }} ></div>
                </div>
                <div className="right_sec">
                    {
                        categoryCTA?.map((cta, i) => {
                            return (
                                <div className="cta">
                                    <a href={cta.link} rel="noreferrer">{cta.text}</a>
                                </div>
                            )
                        })
                    }
                    <div className="pdf_wrapper">
                        <a href={pdfURL} target="_blank" rel="noreferrer">Download our full catalogue in PDF</a>
                    </div>
                </div>
                
            </div>
        </div>
    );
}

export default ForeignRightsIntro;
